import EditMaintainerView from "../../components/EditMaintainerView";

EditMaintainerScreen.propTypes = {};

function EditMaintainerScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="my-4">
                <EditMaintainerView />
            </div>
        </div>
    );
}

export default EditMaintainerScreen;
